module.exports = __webpack_public_path__ + "static/media/ISO.293088e2.png";